// A pool's code, wherever a tracking screen names a pool: it leads to that
// pool's warmup card (UI-6), where its budget, its day and its pause/release
// live. The code is data, not a sentence, so it is set in DM Mono.

import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function poolHref(pool: string): string {
  return `/warmup?pool=${encodeURIComponent(pool)}`;
}

export function PoolLink({ pool, className }: { pool: string; className?: string }) {
  return (
    <Link
      to={poolHref(pool)}
      className={cn("data-mono font-semibold text-ink hover:text-blue-ink", className)}
      title={`${pool} — a pool warmup-lapja`}
    >
      {pool}
    </Link>
  );
}
